import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Accordion, AccordionSummary, AccordionDetails, Box, Button, Checkbox, Skeleton, Divider, FormControlLabel, Radio, RadioGroup, Stack, Switch, Typography, Slider, Input } from '@mui/material';
import ExpandMoreRounded from '@mui/icons-material/ExpandMoreRounded';
import { reduxHelper } from '../../config/reduxHelper';
import { useCategoryData } from '../../hooks/useCategoryData';
import { useGetAllTagAndLanguage } from '../../hooks/useGetAlltagAndLanguage';
import FilterList from '../filterList/filterList';
import useDevice from '../../hooks/useDevice';
import { CloseRounded } from '@mui/icons-material';
import { useRouter } from 'next/router';
import { getString } from '../../functions/getString';



export default function CourseFilters({ onApply }) {
    const dispatch = useDispatch();
    const { headers, allCategories = [], allTags = [], allLanguages = [], allSubCategories=[] } = useSelector(s => s.reducer);
    const { query, replace, pathname } = useRouter();

    const certifiedOnly = query.certified === '1';
    const searchText = query.q || '';
    const view = query.view || 'grid';
    const catIds = query.c_id ? query.c_id.split(',') : [];
    const subCatIds = query.sub_id? query.sub_id.split(',') :[];
    const typeFilter = query.type || 'all';
    const orderFiflter = query.order || 'asc';
    const tagFilter = query.tag ? query.tag.split(',') : [];
    const langFilter = query.language ? query.language.split(',') : [];

    const [showAllCategories, setShowAllCategories] = useState(false);
    const [showAllTags, setShowAllTags] = useState(false);
    const [showAllLanguages, setShowAllLanguages] = useState(false);


    const [openIds, setOpenIds] = useState(new Set());
    const isOpen = id => openIds.has(String(id));
    const toggleOpen = id =>
        setOpenIds(s => { const n = new Set(s); const k = String(id); n.has(k) ? n.delete(k) : n.add(k); return n; });
    const openPanel = id =>
        setOpenIds(s => (s.has(String(id)) ? s : new Set([...s, String(id)])));

    useEffect(() => {
        const init = new Set(
            allSubCategories
            .filter(s => subCatIds.includes(String(s.id)))
            .map(s => String(s.ct_parent_id))
        );
        setOpenIds(init);
    }, [allSubCategories, subCatIds.join(',')]);


    const commitTimer = useRef(null)

    // const [inputValue, setInputValue] = useState(query.duration || '');
    const [duration, setDuration] = useState(query.duration || 0);



    const [catsLoading, setCatsLoading] = useState(true);
    const [tagsLoading, setTagsLoading] = useState(true);

    const filtersLoading = catsLoading || tagsLoading

    const { isMobile, isTablet, isDesktop } = useDevice();
    const manualMode = isMobile || isTablet

    useEffect(() => {
        setDuration(Number(query.duration) || 0);
    }, [query.duration]);



    useEffect(() => {
        if (allCategories.length) {
            setCatsLoading(false);
        } else {
            (async () => {
                setCatsLoading(true);
                const { categories, sub_categories } = await useCategoryData();
                dispatch({ type: reduxHelper.UPDATE_ALL_CATEGORIES, payload: categories });
                dispatch({ type: reduxHelper.UPDATE_ALL_SUB_CATEGORIES, payload: sub_categories });
                setCatsLoading(false);
            })();
        }
    }, [allCategories.length, allSubCategories.length, dispatch]);


    useEffect(() => {
        if (allTags.length && allLanguages.length) {
            setTagsLoading(false);
        } else {
            (async () => {
                setTagsLoading(true);
                const { tags, languages } = await useGetAllTagAndLanguage();
                dispatch({ type: reduxHelper.UPDATE_ALL_TAGS, payload: tags });
                dispatch({ type: reduxHelper.UPDATE_ALL_LANGUAGES, payload: languages });
                setTagsLoading(false);
            })();
        }
    }, [allTags.length, allLanguages.length, dispatch]);



    const AccordionFilter = ({ title, children }) => (
        <Box>
            <Accordion disableGutters defaultExpanded sx={{
                boxShadow: 'none !important', '&:before': {
                    display: 'none',
                }
            }}>
                <AccordionSummary expandIcon={<ExpandMoreRounded />}>
                    <Typography sx={{ fontWeight: 600 }}>{title}</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ fontSize: '14px' }}>{children}</AccordionDetails>
            </Accordion>
            <Divider />
        </Box>

    );


    return (
        <Box>
            <Stack spacing={2}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxShadow: { xs: 2, md: "none" } }}>
                    <Box sx={{ display: "flex", gap: 2 }}>
                        <Typography sx={{ fontWeight: 600, fontSize: "16px" }}>{getString("Filters")}</Typography>
                    </Box>

                    <Button size="small" sx={{textTransform:"none"}} onClick={() => { replace({ pathname, query: {} }, undefined, { shallow: true }); }}>
                        {getString("Clear filters")}
                    </Button>
                </Box>


                {filtersLoading
                    ? (
                        <>
                            <Box sx={{ display: 'flex', alignItems: 'center', px: 2, py: 1 }}>
                                <Skeleton variant="circular" width={40} height={20} sx={{ mr: 2 }} />
                                <Skeleton width="30%" height={24} />
                            </Box>

                            {['Categories', 'Type', 'Sort by', 'Tags', 'Languages', 'Duration',].map((title) => (
                                <Accordion key={title} disableGutters sx={{ boxShadow: 'none' }}>
                                    <AccordionSummary expandIcon={<Skeleton variant="circular" width={24} height={24} />}>
                                        <Skeleton width="30%" height={20} />
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        {[...Array(4)].map((_, i) => (
                                            <Box key={i} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                <Skeleton variant="circular" width={20} height={20} sx={{ mr: 1 }} />
                                                <Skeleton width="60%" height={18} />
                                            </Box>
                                        ))}
                                    </AccordionDetails>
                                </Accordion>
                            ))}
                        </>
                    ) : (
                        <>
                            <Divider sx={{ display: { xs: "none", md: "block" } }} />
                            {/* <FormControlLabel
                                control={<Switch checked={certifiedOnly} onChange={e =>
                                    replace({ pathname, query: { ...query, certified: e.target.checked ? '1' : '' } }, undefined, { shallow: true })}
                                />}
                                label="Certified Courses Only"
                            />
                            <Divider /> */}


                            {allCategories.length > 0 && (
                                <AccordionFilter title= {getString("Categories")}>
                                    <Stack>
                                        <FilterList
                                            items={allCategories}
                                            limit={5}
                                            showAll={showAllCategories}
                                            onToggleShowAll={() => setShowAllCategories(b => !b)}
                                            renderItem={(cat) => {
                                                const subs = allSubCategories.filter( (sub) => String(sub.ct_parent_id) === String(cat.id));
                                                const catId = String(cat.id);
                                                const subIds = subs.map(s => String(s.id));
                                                return (
                                                    <Stack key={cat.id} ml={-3} mt={-2.5} >
                                                        <Accordion disableGutters expanded={isOpen(catId)} onChange={() => {}}>
                                                            <AccordionSummary>
                                                                <Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
                                                                    <FormControlLabel
                                                                        onClick={(e) => e.stopPropagation()}
                                                                        control={
                                                                        <Checkbox
                                                                            checked={catIds.includes(catId)}
                                                                            onChange={() => {
                                                                                const parentSelected = catIds.includes(catId);
                                                                                const nextCats = parentSelected
                                                                                    ? catIds.filter((id) => id !== catId)
                                                                                    : Array.from(new Set([...catIds, catId]));
                                                                                const nextSubs = parentSelected
                                                                                    ? subCatIds.filter((id) => !subIds.includes(id))
                                                                                    : Array.from(new Set([...subCatIds, ...subIds]));
                                                                                replace(
                                                                                    { pathname, query: { ...query, c_id: nextCats.join(','), sub_id: nextSubs.join(',') } },
                                                                                    undefined,
                                                                                    { shallow: true }
                                                                                );
                                                                                if (!parentSelected) openPanel(catId);
                                                                            }}

                                                                        />
                                                                        }
                                                                        label={cat.ct_name}
                                                                        sx={{ m:0 }}
                                                                    />
                                                                    {subs.length > 0 && (
                                                                        <ExpandMoreRounded onClick={(e) => { e.stopPropagation(); toggleOpen(catId); }} />
                                                                    )}
                                                                </Box>
                                                            </AccordionSummary>

                                                            {subs.length > 0 && (
                                                                <Stack mt={-3}>
                                                                    <AccordionDetails sx={{ px: 0}}>
                                                                        <Box sx={{ ml: 3 }}>
                                                                            {subs.map((sub) => (
                                                                                <Box
                                                                                    key={sub.id}
                                                                                    sx={{
                                                                                        position: "relative",
                                                                                        pl: 3,
                                                                                        py: 0.5,

                                                                                        "&:before": {
                                                                                            content: '""',
                                                                                            position: "absolute",
                                                                                            left: 12,
                                                                                            top: "50%",
                                                                                            width: 15,
                                                                                            borderTop: "1px solid black",
                                                                                        },

                                                                                        "&:after": {
                                                                                            content: '""',
                                                                                            position: "absolute",
                                                                                            left: 12,
                                                                                            top: 0,
                                                                                            bottom: 0,
                                                                                            borderLeft: "1px solid black",
                                                                                        },
                                                                                        "&:last-of-type:after": {
                                                                                            bottom: "50%",
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                <FormControlLabel control={
                                                                                    <Checkbox
                                                                                        checked ={subCatIds.includes(sub.id)}
                                                                                        onChange={() => {
                                                                                            const sid = String(sub.id);

                                                                                            const nextSubs = subCatIds.includes(sid)
                                                                                                ? subCatIds.filter(id => id !== sid)
                                                                                                : Array.from(new Set([...subCatIds, sid]));

                                                                                            const allNowSelected = subIds.length > 0 && subIds.every(id => nextSubs.includes(id));
                                                                                            const nextCats = allNowSelected
                                                                                                ? Array.from(new Set([...catIds, catId]))
                                                                                                : catIds;

                                                                                            replace(
                                                                                                { pathname, query: { ...query, c_id: nextCats.join(","), sub_id: nextSubs.join(",") } },
                                                                                                undefined,
                                                                                                { shallow: true }
                                                                                                );
                                                                                        }}
                                                                                    />} 
                                                                                    label={sub.ct_name} sx={{ m: 0 }}
                                                                                />
                                                                            </Box>
                                                                            ))}
                                                                        </Box>
                                                                    </AccordionDetails>
                                                                </Stack>
                                                            )}
                                                        </Accordion>
                                                    </Stack>
                                                );
                                            }}
                                        />
                                    </Stack>
                                </AccordionFilter>
                            )}

                            <AccordionFilter title={getString("Type")}>
                                <RadioGroup value={query.type || 'courses'}
                                    onChange={(_, v) => {
                                        replace(
                                            {
                                                pathname,
                                                query: { ...query, type: v }
                                            },
                                            undefined,
                                            { shallow: true }
                                        );
                                    }}
                                >
                                    {/* <FormControlLabel value="all" control={<Radio />} label="All" /> */}
                                    <FormControlLabel value="courses" control={<Radio />} label="Courses" />
                                    <FormControlLabel value="bundles" control={<Radio />} label="Learning paths" />
                                </RadioGroup>
                            </AccordionFilter>

                            <AccordionFilter title={getString("Sort by")}>
                                <RadioGroup value={query.order || 'asc'}
                                    onChange={(_, v) => {
                                        replace(
                                            {
                                                pathname,
                                                query: { ...query, order: v }
                                            },
                                            undefined,
                                            { shallow: true }
                                        );
                                    }}
                                >
                                    <FormControlLabel value="asc" control={<Radio />} label="Title: A-to-Z" />
                                    <FormControlLabel value="desc" control={<Radio />} label="Title: Z -to-A" />
                                </RadioGroup>
                            </AccordionFilter>


                            <Accordion disableGutters defaultExpanded sx={{ boxShadow: 'none !important', '&:before': { display: 'none', } }}>
                                <AccordionSummary expandIcon={<ExpandMoreRounded />}>
                                    <Typography sx={{ fontWeight: 600}}>
                                        {getString("Duration")}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Box sx={{ display: "flex", gap: "10px", }}>
                                        <Slider
                                            value={duration}
                                            step={50}
                                            marks
                                            valueLabelDisplay="on"
                                            min={0} max={300}
                                            sx={{
                                                height: "6px",
                                                marginTop:"10px",
                                                ml:"10px",
                                                '& .MuiSlider-valueLabel': {
                                                    fontSize:"16px",
                                                    top:"-4px",
                                                    background: 'transparent',
                                                    color: '#000',
                                                },
                                            }}
                                            onChangeCommitted={(event, value) => {
                                                setDuration(value);
                                                replace(
                                                    { pathname, query: { ...query, duration: value } },
                                                    undefined,
                                                    { shallow: true }
                                                );
                                            }}
                                        />
                                        <Input
                                            value={duration}
                                            size="small"
                                            sx={{ bottom: "5px" }}
                                            inputProps={{ min: 0, max: 300, type: 'number', 'aria-labelledby': 'input-slider' }}
                                            onChange={e => {
                                                const value = e.target.value
                                                if (value === '' || (!isNaN(value) && (value) <= 300)) {
                                                    setDuration(value);
                                                    clearTimeout(commitTimer.current)
                                                    commitTimer.current = setTimeout(() => {
                                                        replace(
                                                            { pathname, query: { ...query, duration: value } },
                                                            undefined,
                                                            { shallow: true }
                                                        );
                                                    }, 1000)
                                                }
                                            }}

                                        />
                                        <Typography fontSize={16} fontWeight={600}>hrs</Typography>
                                    </Box>
                                </AccordionDetails>
                            </Accordion>
                            <Divider />

                            {allTags.length > 0 && (
                                <AccordionFilter title={getString("Tags")}>
                                    <Stack>
                                        <FilterList
                                            items={allTags}
                                            limit={5}
                                            showAll={showAllTags}
                                            onToggleShowAll={() => setShowAllTags(b => !b)}
                                            renderItem={tag => (
                                                <FormControlLabel
                                                    key={tag}
                                                    control={
                                                        <Checkbox
                                                            checked={tagFilter.includes(tag)}
                                                            onChange={() => {
                                                                const next = tagFilter.includes(tag)
                                                                    ? tagFilter.filter(t => t !== tag)
                                                                    : [...tagFilter, tag];
                                                                replace(
                                                                    { pathname, query: { ...query, tag: next.join(',') } },
                                                                    undefined,
                                                                    { shallow: true }
                                                                );
                                                            }

                                                            }
                                                        />
                                                    }
                                                    label={tag}
                                                />
                                            )}
                                        />
                                    </Stack>
                                </AccordionFilter>
                            )}




                            {allLanguages.length > 0 && (
                                <AccordionFilter title={getString("Languages")}>
                                    <Stack>
                                        <FilterList
                                            items={allLanguages}
                                            limit={5}
                                            showAll={showAllLanguages}
                                            onToggleShowAll={() => setShowAllLanguages(b => !b)}
                                            renderItem={(lang) => (
                                                <FormControlLabel
                                                    key={lang.code}
                                                    control={
                                                        <Checkbox
                                                            checked={langFilter.includes(lang.code)}
                                                            onChange={() => {
                                                                next = langFilter.includes(lang.code)
                                                                    ? langFilter.filter(c => c !== lang.code)
                                                                    : [...langFilter, lang.code];

                                                                replace(
                                                                    { pathname, query: { ...query, language: next.join(',') } },
                                                                    undefined,
                                                                    { shallow: true }
                                                                );
                                                            }}
                                                        />
                                                    }
                                                    label={lang.name}
                                                />
                                            )}
                                        />
                                    </Stack>
                                </AccordionFilter>
                            )}


                            {/* {manualMode && (
                                <Box sx={{ p: 2, bgcolor: 'background.paper' }}>
                                    <Button variant="contained" fullWidth onClick={() => {
                                        onApply?.();
                                    }}>
                                        Apply
                                    </Button>
                                </Box>
                            )} */}
                        </>

                    )

                }

            </Stack>
        </Box>
    );
}